export { FullWidthText } from './FullWidthText';
